import { render, staticRenderFns } from "./BuyBoxFreeTrialSwiperOSContainer.vue?vue&type=template&id=4834db08&scoped=true"
import script from "./BuyBoxFreeTrialSwiperOSContainer.vue?vue&type=script&lang=ts&setup=true"
export * from "./BuyBoxFreeTrialSwiperOSContainer.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./BuyBoxFreeTrialSwiperOSContainer.vue?vue&type=style&index=0&id=4834db08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4834db08",
  null
  
)

export default component.exports